import { create } from 'zustand';
import { Dayjs } from 'dayjs';

export enum TransactionStatusEnum {
  ENABLED = 'enabled',
  PAID = 'paid',
  PENDING = 'pending',
}

export enum TransactionTypeEnum {
  WITHDRAW = 'withdraw',
  DEPOSIT = 'deposit',
}

export interface TransactionFilters {
  statusFilter: TransactionStatusEnum[];
  typeFilter?: TransactionTypeEnum;
  createdAtFilter?: [Dayjs, Dayjs];
}

interface StoreAndActions extends TransactionFilters {
  setStatus: (value: TransactionStatusEnum[]) => void;
  setType: (value?: TransactionTypeEnum) => void;
  setCreatedAt: (value?: [Dayjs, Dayjs]) => void;
  resetFilers: () => void;
}

const useTransactionFilteringStore = create<StoreAndActions>((set, get) => ({
  statusFilter: [],
  typeFilter: undefined,
  createdAtFilter: undefined,
  setStatus: (value) => set({ statusFilter: value }),
  setType: (value) => set({ typeFilter: value }),
  setCreatedAt: (value) => set({ createdAtFilter: value }),
  resetFilers: () => {
    set({
      createdAtFilter: undefined,
      statusFilter: [],
      typeFilter: undefined,
    });
  },
}));

export default useTransactionFilteringStore;
